<template>
  <button
    v-if="tooltipText"
    v-on="isTouch ? {click: toggleTooltip} : {mouseenter: showTooltip, mouseleave: hideTooltip}"
    class="info-button"
    :class="{ 'info-button--error': isError }"
  >
    <svg class="info-button__svg" width="20" height="20">
      <use :xlink:href="spritePath + '#info-icon'"></use>
    </svg>
    <Tooltip
      :is-visible="isTooltipVisible"
      :horizontal-align="tooltipHorizontalAlign"
      :vertical-align="tooltipVerticalAlign"
      :is-arrow="tooltipIsArrow"
      :is-arrow-right="tooltipIsArrowRight"
      :is-up="tooltipIsUp"
      :html-text="tooltipText"
      :max-width="maxTooltipWidth"
    />
  </button>
</template>

<script>
import { spritePath } from '../../mixins/spritePath'
import { isTouch } from '../../mixins/isTouchDevice'
import Tooltip from './Tooltip'

export default {
  name: 'InfoButton',
  components: { Tooltip },
  mixins: [spritePath, isTouch],
  props: {
    tooltipHorizontalAlign: {
      type: String,
      default: 'center'
    },
    tooltipVerticalAlign: {
      type: String,
      default: 'bottom'
    },
    tooltipText: String,
    tooltipIsArrow: Boolean,
    tooltipIsUp: Boolean,
    tooltipIsArrowRight: Boolean,
    isError: Boolean,
    maxTooltipWidth: {
      type: String,
      default: 'auto'
    }
  },
  data () {
    return {
      timeout: null,
      isTooltipVisible: false
    }
  },
  methods: {
    toggleTooltip () {
      this.isTooltipVisible = !this.isTooltipVisible
    },
    showTooltip () {
      clearTimeout(this.timeout)
      this.isTooltipVisible = true
    },
    hideTooltip () {
      if (this.isTouch) {
        this.isTooltipVisible = false
      } else {
        this.timeout = setTimeout(() => { this.isTooltipVisible = false }, 300)
      }
    }
  }
}
</script>

<style scoped lang="sass">
.info-button
  position: relative
  display: flex
  width: max-content
  padding: 0
  margin: 0
  background: transparent
  border: none
  cursor: pointer

.info-button__svg
  fill: #ccc

.info-button--error .info-button__svg
  fill: $nd-error-text-color

</style>
